import { STRINGS } from '../../constants';
import filterEmptyParams from '../../utils/filters';
import apiCaller from '../http';
import URLS from '../urls';

const deleteServiceCartItem = async (
  visitId,
  data,
  setError,
  refreshVisitDetail,
  logoutHandler,
) => {
  const payload = { item_id: data?.id };
  await apiCaller
    .put(`${URLS.SERVICE_CART_DESTROY_ITEM}${visitId}/`, filterEmptyParams(payload))
    .then(() => {
      setError(null);
      refreshVisitDetail();
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400Text);
      }
    });
};

export default deleteServiceCartItem;
